const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "25%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "10%"
  },
  {
    key: "maintainTimeSetting",
    zh: "保养设置时间(h)",
    en: "Maintain Time Setting(h)",
    width: "22%"
  },
  {
    key: "maintainTime",
    zh: "当前保养时间(h)",
    en: "Maintain Time(h)",
    width: "16%"
  },
  {
    key: "runTime",
    zh: "累积运行时间(h)",
    en: "Running Time(h)",
    width: "13%"
  }
]

export default columns